import { isScrolledIntoView } from './scrolled-into-view';

export const infinite = {
    init: function() {
        const $ = jQuery;

        const self = this;

    	$(window).on('scroll', function(e) {
            if ( $('#infinite-trigger').length > 0 && isScrolledIntoView( $('#infinite-trigger') ) && ! self.loading && $('#infinite-trigger').data('active') ) {
                self.handler();
            }
        });
    },
    loading: false,
    handler: function() {
        const $ = jQuery;

        const self = this;

        self.loading = true;

        const data = $('#infinite-trigger').data();

        $.ajax({
            url: wpApiSettings.root + 'iboards/v1/infinite',
            method: 'GET',
            data,
            success: (response) => {
                console.log(response);
                if (response.html.length > 0) {
                    const container = $('#cards-grid');
                    
                    if (container.length > 0) {
                        $(container).append(response.html);
                    }
                }

                $('#infinite-trigger').data('next', data.next + 1);

                if (response.more_posts) {
                    $('#infinite-trigger').data('active', true);
                } else {
                    $('#infinite-trigger').data('active', false);
                }

                self.loading = false;
            },
            error: (response) => {
                console.log(response);
            }
        });
    }
}